import React, { FC } from 'react';
import { AuthForm } from '../../features/forms/AuthForm/index';

export const AuthScreen: FC = () => {
  return (
    <div>
      <AuthForm />
    </div>
  );
};
